<template>
  <div class="pt-4">
    <v-radio-group v-model="computedValue.type" row>
      <v-radio
          :label="$t('emailSettings.realPerson')"
          value="regular"
      />
      <v-radio
          :label="$t('emailSettings.legalPerson')"
          value="legal"
      />
    </v-radio-group>

    <div v-if="userInfo" class="m-4">
      <v-row>
        <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
          <v-text-field
              :value="user.name"
              color="gray"
              dense
              :label="$t('personalInformation.name')"
              outlined
              readonly
              type="text"
          />
        </v-flex>

        <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
          <v-text-field
              :value="user.phone"
              color="gray"
              dense
              :label="$t('userInfoForm.phone')"
              outlined
              readonly
              type="text"
          />
        </v-flex>
        <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
          <v-text-field
              v-model="computedValue.telephone"
              :error-messages="errorsMessage.telephone"
              dense
              :label="$t('userInfoForm.telephone')"
              outlined
              type="text"
          />
        </v-flex>
        <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
          <v-text-field
              v-model="computedValue.fatherName"
              :error-messages="errorsMessage.father_name"
              dense
              :label="$t('userInfoForm.fatherName')"
              outlined
              type="text"
          />
        </v-flex>
        <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
          <v-text-field
              :value="user.nid"
              dense
              :label="$t('userInfoForm.nationalCode')"
              outlined
              readonly
              type="text"
          />
        </v-flex>

        <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
          <date-picker
              v-model="computedValue.birthday"
              :error-messages="errorsMessage.birthday"
              :display-format="datePickerFormat"
              format="YYYY-MM-DD"
              :label="$t('userInfoForm.birthday')"
              max="2006-01-01"
              start="2006-01-01"
              view="year"
          />
        </v-flex>
        <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
          <v-text-field
              v-model="computedValue.born_city"
              :error-messages="errorsMessage.born_city"
              dense
              :label="$t('userInfoForm.placeBirthday')"
              outlined
              type="text"
          />
        </v-flex>
        <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
          <v-text-field
              v-model="computedValue.postalCode"
              :error-messages="errorsMessage.postal_code"
              dense
              :label="$t('userInfoForm.postalCode')"
              outlined
              type="text"
          />
        </v-flex>
        <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
          <v-text-field
              :value="user.email"
              dense
              :label="$t('userInfoForm.email')"
              outlined
              readonly
              type="email"
          />
        </v-flex>
        <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
          <v-text-field
              v-model="computedValue.introduction"
              :error-messages="errorsMessage.introduction"
              dense
              :label="$t('userInfoForm.introduction')"
              outlined
              type="text"
          />
        </v-flex>
        <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
          <v-file-input
              v-model="computedValue.nid_img"
              :error-messages="errorsMessage.nid_img"
              append-icon="mdi-camera"
              dense
              :label="$t('userInfoForm.nationalCodePic')"
              outlined
              prepend-icon=""
              show-size
          />
        </v-flex>
        <!-- <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
          <v-text-field
              v-model="computedValue.plaque"
              :error-messages="errorsMessage.plaque"
              dense
              :label="$t('userInfoForm.plaque')"
              outlined
              type="text"
          />
        </v-flex> -->
        <v-col class="pa-2" cols="12">
          <v-textarea
              v-model="computedValue.address"
              :error-messages="errorsMessage.address"
              color="teal"
              dense
              :label="$t('userInfoForm.address')"
              outlined
              rows="3"
          />
        </v-col>
      </v-row>

      <div v-if="computedValue.type === 'legal'" class="m-4">
        <v-row>
          <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
            <v-text-field
                v-model="computedValue.company_name"
                :error-messages="errorsMessage.company_name"
                class="mt-4"
                dense
                direction="rtl"
                :label="$t('userInfoForm.companyName')"
                outlined
                type="text"
            />
          </v-flex>
          <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
            <v-text-field
                v-model="computedValue.registrationNumber"
                :error-messages="errorsMessage.registration_number"
                class="mt-4"
                dense
                :label="$t('userInfoForm.registrationNumber')"
                outlined
                type="text"
            />
          </v-flex>
        </v-row>
        <v-row>
          <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
            <v-text-field
                v-model="computedValue.economicCode"
                :error-messages="errorsMessage.economic_code"
                class="mt-4"
                dense
                direction="rtl"
                :label="$t('userInfoForm.economicCode')"
                outlined
                type="text"
            />
          </v-flex>
          <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
            <v-text-field
                v-model="computedValue.organizationIdentity"
                :error-messages="errorsMessage.organization_identity"
                class="mt-4"
                dense
                :label="$t('userInfoForm.organizationIdentity')"
                outlined
                type="text"
            />
          </v-flex>
        </v-row>
        <v-row>
          <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
            <v-select
                v-model="computedValue.companyType"
                :error-messages="errorsMessage.company_type"
                :items="translatedItems"
                dense
                item-text="name"
                item-value="valueName"
                :label="$t('userInfoForm.companyType')"
                outlined
            />
          </v-flex>
          <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
            <v-text-field
                v-model="computedValue.activity"
                :error-messages="errorsMessage.activity"
                dense
                :label="$t('userInfoForm.activity')"
                outlined
                type="text"
            />
          </v-flex>
        </v-row>
        <!--        <v-row>-->
        <!--          <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>-->
        <!--            <v-file-input-->
        <!--                v-model="computedValue.registrationAd"-->
        <!--                :error-messages="errorsMessage.registration_ad"-->
        <!--                counter-->
        <!--                dense-->
        <!--                :label="$t('userInfoForm.registrationAd')"-->
        <!--                outlined-->
        <!--                prepend-icon="mdi-camera"-->
        <!--            />-->
        <!--          </v-flex>-->
        <!--          <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>-->
        <!--            <v-file-input-->
        <!--                v-model="computedValue.lastPublishedAd"-->
        <!--                :error-messages="errorsMessage.last_published_ad"-->
        <!--                counter-->
        <!--                dense-->
        <!--                :label="$t('userInfoForm.lastPublishedAd')"-->
        <!--                outlined-->
        <!--                prepend-icon="mdi-camera"-->
        <!--            />-->
        <!--          </v-flex>-->
        <!--        </v-row>-->
        <!--        <v-row>-->
        <!--          <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>-->
        <!--            <v-file-input-->
        <!--                v-model="computedValue.statute"-->
        <!--                :error-messages="errorsMessage.statute"-->
        <!--                counter-->
        <!--                dense-->
        <!--                :label="$t('userInfoForm.statute')"-->
        <!--                outlined-->
        <!--                prepend-icon="mdi-camera"-->
        <!--            />-->
        <!--          </v-flex>-->
        <!--          <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>-->
        <!--            <v-file-input-->
        <!--                v-model="computedValue.agent_letterpic"-->
        <!--                :error-messages="errorsMessage.agent_letterpic"-->
        <!--                counter-->
        <!--                dense-->
        <!--                :label="$t('userInfoForm.argent_letter_pic')"-->
        <!--                outlined-->
        <!--                prepend-icon="mdi-camera"-->
        <!--            />-->
        <!--          </v-flex>-->
        <!--        </v-row>-->
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";

export default {
  props: {
    value: Object,
    errorsMessage: Object
  },
  i18n,
  data() {
    return {
      userInfo: null,
      rules: {},
      items: [
        {
          name: this.$t("userInfoForm.companyTypes.governmental"),
          valueName: "governmental",
        },
        {
          name: this.$t("userInfoForm.companyTypes.private"),
          valueName: "private",
        },
        {
          name: this.$t("userInfoForm.companyTypes.common_stock"),
          valueName: "common_stock",
        },
        {
          name: this.$t("userInfoForm.companyTypes.special_stock"),
          valueName: "special_stock",
        },
      ],
      data: null,
      rejectMessage: null,
    };
  },
  mounted() {
    this.getInfo();
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    showMessage() {
      return this.rejectMessage.split("\n");
    },
    translatedItems() {
      return [
        {
          name: this.$t("userInfoForm.companyTypes.governmental"),
          valueName: "governmental",
        },
        {
          name: this.$t("userInfoForm.companyTypes.private"),
          valueName: "private",
        },
        {
          name: this.$t("userInfoForm.companyTypes.common_stock"),
          valueName: "common_stock",
        },
        {
          name: this.$t("userInfoForm.companyTypes.special_stock"),
          valueName: "special_stock",
        },
      ];
    },
    datePickerFormat() {
      return this.$i18n.locale === "fa" ? "jYYYY-jMM-jDD" : "YYYY-MM-DD";
    },
  },
  methods: {
    getInfo() {
      this.requestApiGet(`authRequest/${this.user.id}`).then(({data}) => {
        this.userInfo = data;
        this.rejectMessage = data.extras?.adminMessage;
        this.computedValue.type = data?.type;
        this.setUserLegal(data);
        this.setUserRegular(data);
      });
    },
    setUserLegal(data) {
      this.computedValue.company_name = data.bussiness?.company_name;
      this.computedValue.companyType = data.bussiness?.company_type;
      this.computedValue.registrationNumber =
          data.bussiness?.registration_number;
      this.computedValue.economicCode = data.bussiness?.economic_code;
      this.computedValue.organizationIdentity =
          data.bussiness?.organization_identity;
      this.computedValue.activity = data.bussiness?.activity;
      this.computedValue.registrationAd = data.bussiness?.registration_ad;
      this.computedValue.lastPublishedAd = data.bussiness?.last_published_ad;
      this.computedValue.statute = data.bussiness?.statute;
    },
    setUserRegular(data) {
      this.computedValue.name = data.name;
      this.computedValue.phone = data.phone;
      this.computedValue.fatherName = data?.user_info?.father_name;
      this.computedValue.nid = data.user_info?.nid;
      this.computedValue.birthday = data.user_info?.birthday;
      this.computedValue.born_city = data.user_info?.born_city;
      this.computedValue.address = data.user_info?.address;
      this.computedValue.postalCode = data.user_info?.postalCode;
      this.computedValue.nid_img = data.user_info?.nid_img;
      this.computedValue.telephone = data.user_info?.telephone;
      this.computedValue.username = data.user_info?.username;
      // this.computedValue.plaque = data.user_info?.plaque;
      console.log(this.computedValue,"check_data ")

    },
  },
};
</script>
